import { Component } from 'react';
import { toast } from 'react-toastify';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Layout from '../DashboardLayout';
import Loader from '../../components/Loader';
import TeamList from '../../components/settings/TeamList';
import CurrentTeam from '../../components/settings/CurrentTeam';
import AutoCheckout from '../../components/settings/AutoCheckout';
import TimesheetApproval from '../../components/settings/TimesheetApproval';
import SettingsTabs from '../../components/settings/Tabs';
import { setUserRole } from '../../actions/user';
import {
  enableTimesheetApproval,
  disableTimesheetApproval,
} from '../../actions';

import { teamService, settingsService, userService } from '../../services';

import {
  LOCAL_STORAGE_USER_DATA,
  SETTINGS_TEAMS,
  API_FAILURE_ERROR,
} from '../../constants';
import { updateLocalStorage, getUserData } from '../../helpers';

class Teams extends Component {
  pageHeading = {
    preTitle: 'Settings',
    title: 'Teams',
  };

  userdata = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_DATA));

  state = {
    defaultTeam:
      this.userdata.defaultTeam != null
        ? `${this.userdata.defaultTeam.firstName} ${this.userdata.defaultTeam.lastName}`
        : '',
    defaultChecked: this.userdata.defaultTeam.isDefault,
    autoCheckOut: false,
    autoCheckOutMinutes: '',
    timeSheetApproval: getUserData('isTimesheetApproval'),
    isLoading: false,
    teamList: [],
    memberList: '',
    role:
      this.userdata.defaultTeam != null
        ? this.userdata.defaultTeam.role
        : 'creator',
  };

  componentDidMount() {
    this.setState((state) => ({
      ...state,
      isLoading: true,
    }));

    this.getMembers(localStorage.getItem('teamOwnerId'));

    if (
      this.userdata.defaultTeam &&
      this.userdata.defaultTeam.role === 'creator'
    ) {
      this.getAutoCheckOutSettings();
      // this.getTimesheetApprovalStatus();
    }
    this.getTeams();
  }

  /* get the auto checkout settings */
  getAutoCheckOutSettings = () => {
    this.setState((state) => ({
      ...state,
      isLoading: true,
    }));

    settingsService
      .get_settings()
      .then((response) => {
        if (Object.keys(response.data).length > 0) {
          this.setState((state) => ({
            ...state,
            isLoading: false,
            autoCheckOut: response.data.autoCheckOut,
            autoCheckOutMinutes:
              response.data.autoCheckOutMinutes === 0
                ? ''
                : response.data.autoCheckOutMinutes,
          }));
        } else {
          this.setState((state) => ({
            ...state,
            isLoading: false,
          }));
        }
      })
      .catch((errResp) => {
        toast.error(API_FAILURE_ERROR);
        this.setState((state) => ({
          ...state,
          isLoading: false,
        }));
      });
  };

  /* Update current team as default team */
  handleUpdateDefault = () => {
    const { defaultChecked } = this.state;

    this.setState((state) => ({
      ...state,
      isLoading: true,
    }));

    teamService
      .update_default_team({
        teamOwnerId: !defaultChecked ? localStorage.getItem('teamOwnerId') : '',
      })
      .then((response) => {
        if (defaultChecked) {
          toast.success(SETTINGS_TEAMS.UPDATE_TEAM_UNSET);
        } else {
          toast.success(SETTINGS_TEAMS.UPDATE_TEAM_SET);
        }

        this.setState((state) => ({
          ...state,
          isLoading: false,
          defaultChecked: !defaultChecked,
        }));

        /* update default team in local storage */
        const { defaultTeam } = this.userdata;
        defaultTeam.isDefault = !defaultChecked;
        updateLocalStorage({
          defaultTeam,
        });
      })
      .catch((error) => {
        toast.error(SETTINGS_TEAMS.UPDATE_ERROR);

        this.setState((state) => ({
          ...state,
          isLoading: false,
        }));
      });
  };

  /* update auto checkout value */
  handleUpdateAutoCheckout = (formData) => {
    this.setState((state) => ({
      ...state,
      isLoading: true,
    }));

    if (formData.autoCheckOut === false) {
      formData.autoCheckOutMinutes = 0;
    }

    settingsService
      .update_autocheckout(formData)
      .then(() => {
        if (formData.autoCheckOut === false) {
          toast.success(SETTINGS_TEAMS.UPDATE_AUTOCHECKOUT_UNSET);
        } else {
          toast.success(SETTINGS_TEAMS.UPDATE_AUTOCHECKOUT_SET);
        }

        this.setState((state) => ({
          ...state,
          isLoading: false,
          autoCheckOut: formData.autoCheckOut,
          autoCheckOutMinutes:
            formData.autoCheckOutMinutes === 0
              ? ''
              : formData.autoCheckOutMinutes,
        }));
      })
      .catch((err) => {
        toast.error(SETTINGS_TEAMS.UPDATE_ERROR);
        this.setState((state) => ({
          ...state,
          isLoading: false,
        }));
      });
  };

  handleUpdateTimesheetApproval = (formData) => {
    const { enableTsApproval, disableTsApproval } = this.props;
    this.setState((state) => ({
      ...state,
      isLoading: true,
    }));
    const data = {
      teamOwnerId: localStorage.getItem('teamOwnerId'),
      status: formData.timesheetApproval,
    };

    settingsService
      .timesheet_approval(data)
      .then((res) => {
        if (res.status) {
          userService
            .get_account_details({
              teamOwnerId: localStorage.getItem('teamOwnerId'),
            })
            .then((response) => {
              if (response.data) {
                updateLocalStorage({
                  isTimesheetApproval: response.data.isTimesheetApproval,
                });
              }
            });
        }
        if (formData.timesheetApproval === false) {
          toast.success(SETTINGS_TEAMS.TIMESHEET_APPROVAL_UNSET);
          disableTsApproval();
        } else {
          toast.success(SETTINGS_TEAMS.TIMESHEET_APPROVAL_SET);
          enableTsApproval();
        }

        this.setState((state) => ({
          ...state,
          isLoading: false,
          timeSheetApproval: formData.timesheetApproval,
        }));
      })
      .catch((err) => {
        toast.error(SETTINGS_TEAMS.UPDATE_ERROR);
        this.setState((state) => ({
          ...state,
          isLoading: false,
        }));
      });
  };

  /* refresh components after team change */
  handleTeamSelection = (formData) => {
    localStorage.setItem('teamOwnerId', formData.teamOwners);
    toast.success(SETTINGS_TEAMS.TEAM_CHANGE);
    formData.teamDetails[0].isDefault = false;
    updateLocalStorage({ defaultTeam: formData.teamDetails[0] });

    const { dispatch } = this.props;
    dispatch(
      setUserRole({
        role: formData.teamDetails[0].role,
        ownerId: formData.teamOwners,
      })
    );

    this.setState((state) => ({
      ...state,
      defaultTeam: `${formData.teamDetails[0].firstName} ${formData.teamDetails[0].lastName}`,
      defaultChecked: false,
      autoCheckOut: false,
      autoCheckOutMinutes: '',
      isLoading: false,
      memberList: [],
      role: formData.teamDetails[0].role,
    }));

    if (formData.teamDetails[0].role === 'creator') {
      this.getAutoCheckOutSettings();
    }
    delete formData.teamDetails;
    this.getMembers(formData.teamOwners);
  };

  /* Data for listing teams in change team */
  getTeams = () => {
    this.setState((state) => ({
      ...state,
      isLoading: true,
    }));

    teamService
      .get_teams_data()
      .then((resp) => {
        if (resp.data.length > 1) {
          this.setState((state) => ({
            ...state,
            teamList: resp.data,
            isLoading: false,
          }));
        } else {
          this.setState((state) => ({
            ...state,
            teamList: [],
            isLoading: false,
          }));
        }
      })

      .catch(() => {
        toast.error(API_FAILURE_ERROR);
      });
  };

  getMembers = (ownerId) => {
    this.setState((state) => ({
      ...state,
      isLoading: true,
    }));
    teamService
      .get_team_members_data({
        teamOwnerId: ownerId,
        summaryList: true,
        filter: '{ "memberStatus": "active" }',
      })
      .then((response) => {
        this.setState((state) => ({
          ...state,
          memberList:
            response && 'data' in response ? response.data.members : [],
          isLoading: false,
        }));
      })
      .catch(() => {
        this.setState((state) => ({
          ...state,
          memberList: [],
          isLoading: false,
        }));
      });
  };

  render() {
    const {
      defaultTeam,
      defaultChecked,
      autoCheckOut,
      autoCheckOutMinutes,
      timeSheetApproval,
      isLoading,
      teamList,
      memberList,
      role,
    } = this.state;

    return (
      <Layout pageHeading={this.pageHeading}>
        {isLoading && <Loader contentAreaOnly />}
        <Row className="justify-content-center">
          <Col className="col-12 col-lg-10 col-xl-8">
            <SettingsTabs selectedTab={this.pageHeading.title} />
            <div className="tab-content">
              <div className="tab-pane show active">
                <Row>
                  {teamList.length > 1 && (
                    <CurrentTeam
                      defaultTeam={defaultTeam}
                      handleUpdateDefault={this.handleUpdateDefault}
                      propChecked={defaultChecked}
                      teamList={teamList}
                      handleTeamSelection={this.handleTeamSelection}
                    />
                  )}
                  {!isLoading && role === 'creator' && (
                    <AutoCheckout
                      checkoutSetting={autoCheckOut}
                      checkoutMinutes={autoCheckOutMinutes}
                      handleUpdate={this.handleUpdateAutoCheckout}
                    />
                  )}
                  {!isLoading && role === 'creator' && (
                    <TimesheetApproval
                      isTsheeApprovalEnabled={timeSheetApproval}
                      handleUpdateTSApproval={
                        this.handleUpdateTimesheetApproval
                      }
                    />
                  )}
                </Row>
                {memberList.length > 0 ? (
                  <TeamList memberList={memberList} />
                ) : (
                  memberList !== '' && (
                    <div className="card">
                      <div className="card-body d-flex justify-content-center">
                        <div className="alert alert-info">No members </div>
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
          </Col>
        </Row>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  isTimesheetApproval: state.timesheetApproval,
});

const mapDispatchToProps = () => ({
  enableTsApproval: enableTimesheetApproval,
  disableTsApproval: disableTimesheetApproval,
});

Teams.propTypes = {
  dispatch: PropTypes.any,
  enableTsApproval: PropTypes.func,
  disableTsApproval: PropTypes.func,
};
export default connect(mapStateToProps, mapDispatchToProps())(Teams);
